import { PythonTopic } from '../../../../types/python-topic';
import { contenedoresErroresExercises } from './exercises';

export const contenedoresErroresTopic: PythonTopic = {
  id: 1,
  title: 'Contenedores y Errores',
  description: 'Aprende a trabajar con contenedores (listas, tuplas, diccionarios, sets) y manejar errores en Python.',
  theory: `# Contenedores y Errores en Python

## ¿Qué aprenderás en esta sección?

Esta sección te introduce a:
1. **Contenedores**: Listas, tuplas, diccionarios y sets
2. **Manejo de bugs y errores**: Cómo identificar y corregir errores
3. **Llamados desde línea de comandos**: Interacción con el sistema

## Contenedores en Python

Python ofrece varios tipos de contenedores:
- **Listas**: Colecciones ordenadas y mutables
- **Tuplas**: Colecciones ordenadas e inmutables
- **Diccionarios**: Asociaciones clave-valor
- **Sets**: Colecciones sin duplicados

Cada tipo tiene sus ventajas según el caso de uso.

## Manejo de Errores

Aprenderás a:
- Identificar diferentes tipos de errores
- Usar try-except para manejar excepciones
- Depurar código efectivamente

## Estructura de esta sección

Cada ejercicio incluye teoría expandida, ejemplos prácticos y ejercicios para que puedas practicar a tu propio ritmo.`,
  difficulty: 'intermediate',
  exercises: contenedoresErroresExercises
};

